import { HandleProcurementApprovalsDataGet } from '../../../application';

export default class DataGetService {
    async RequestData(event) {
        const data = await HandleProcurementApprovalsDataGet(event);

        return data;
    }
}
